import { Switch, Tooltip, Typography } from "@mui/material";
import PopoverMenuItem from "@entrilia/shared/components/PopoverMenuItem";

interface Props {
  caption: string;
  value: boolean;
  onClick: () => void;
  disabled: boolean;
  tooltip?: string;
}

export default function SwitchMenuItem({ caption, value, onClick, disabled, tooltip }: Props) {
  return (
    <PopoverMenuItem
      sx={{ display: "flex", flex: 1, flexDirection: "row", "&.Mui-disabled": { opacity: 1 } }}
      onClick={onClick}
      disabled={disabled}
    >
      <Tooltip title={tooltip}>
        <Typography sx={{ display: "flex", flex: 1 }}>{caption}</Typography>
      </Tooltip>
      <Switch checked={value} disabled={disabled} />
    </PopoverMenuItem>
  );
}
